<template>
  <CModal
    :show.sync="showCenterLogModal"
    :no-close-on-backdrop="true"
    :centered="true"
    title="Modal title 2"
    size="lg"
    class="view-log-modal input-container modal-log-btn mobile-log-details modal-width"
  >
    <template #header>
      <h6 class="modal-title">View Log</h6>
      <CButtonClose @click="closeModal()" />
    </template>
    <div>
      <div class="doctor-log-list mb-3">
        <p class="mb-0">{{ centerData.center_id.general.name }}</p>
      </div>
      <div>
        <table class="table small-table-padding">
          <tbody>
            <tr v-for="(history, index) in centerData.histories" :key="index">
              <td>Status: {{ history.current_document_status }}</td>
              <td>{{ dateLabel(history) }}</td>
              <td>
                <a
                  @click="getViewDetails(history)"
                  class="cursor btn text-uppercase btn-outline-primary btn-block"
                  :class="{
                    'disabled-style': !history.registration_proof_image_url,
                  }"
                >View</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </CModal>
</template>
<script>
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
const imagePreview = () => import("@/components/modals/imagePreview.vue");
import formats from "@/formats";
export default {
  props: ["showCenterLogModal", "centerData"],
  components: {
    "image-preview": imagePreview
  },
  data() {
    return {
      dayJS,
      formats
    };
  },
  methods: {
    getViewDetails(history) {
      this.$emit("openViewDetails", history);
    },
    closeModal() {
      this.$emit("close");
    },
    dateLabel(history) {
      let text = "";
      switch (history.current_document_status) {
        case "PENDING":
          text = `Requested on : ${dayJS(history.document_uploaded_date).format(
            formats.date_time_format
          )}`;
          break;
        case "APPROVED":
          text = `Approved on : ${dayJS(
            history.approved_details.approved_on
          ).format(formats.date_time_format)}`;
          break;
        case "UPDATED":
          text = `Updated on : ${dayJS(history.document_uploaded_date).format(
            formats.date_time_format
          )}`;
          break;
        case "REJECT":
          text = `Rejected on : ${dayJS(
            history.rejected_details.rejected_on
          ).format(formats.date_time_format)}`;
          break;
      }
      return text;
    }
  }
};
</script>
<style lang="scss" scoped>
.view-log-modal{
  .btn-primay{
    background-color:transparent!important;
    border-color: #321fdb!important;
  }
}



</style>